import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Cabnet from "./pages/Cabnet";
import Doors from "./pages/Doors";
import Partition from "./pages/Partition";
import './index.css';
import Windows from "./pages/Windows";
import Elevation from "./pages/Elevations";
import Wardrobe from "./pages/Wardrobe";




function App() {
  return (
    <header>
      <Navbar />

      <div className="container mt-4" style={{ paddingTop: "50px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/windows" element={<Windows />} />
          <Route path="/doors" element={<Doors />} />
          <Route path="/partition" element={<Partition />} />
          <Route path="/elevation" element={<Elevation />} />
          <Route path="/wardrobe" element={<Wardrobe />} />
          <Route path="/cabnet" element={<Cabnet />} />



          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </div>
      <Services />
      <Footer />
    </header>
  );
}

export default App;

